export default {
    bind (el, binding, vnode) {
        function handler(e){
            e = e || window.event;
            if(el.contains(e.target) || !binding.expression){ return; }
            if(typeof(binding.value) === 'function'){ return binding.value(e); }
            (new Function('obj', `obj.${binding.expression}`))(vnode.context);
        }
        el._vueClickOut_ = handler;
        document.addEventListener('click', handler);
    },
    unbind (el) {
        document.removeEventListener('click', el._vueClickOut_);
        delete el._vueClickOut_;
    }
}
